/// <reference types="vite/client" />
import { createApp } from 'vue'
/* Pinia */
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router';

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/cliente.css';

/* axios */
import axios from 'axios'
import VueAxios from 'vue-axios'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import { icons } from './assets/icons';

import * as Sentry from "@sentry/vue";
//import { useUserStore } from './stores/store.user';

// Importa la configuración de Axios para inicializarla (opcional)
import './api/axiosConfig';

/* add icons to the library */
library.add(icons)

const app = createApp(App)
  .use(createPinia())
  .use(IonicVue)
  .use(router)
  .use(VueAxios, axios)
  ;

app.component('font-awesome-icon', FontAwesomeIcon);

if(import.meta.env.VITE_ENV != 'local'){

  Sentry.init({
    app,
    dsn: "https://5a6595be13928fce3f7853adb36af767@o4508483135864832.ingest.de.sentry.io/4508483578626128",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [import.meta.env.VITE_APP_API_URL,import.meta.env.VITE_APP_API_NOTIFICACION_URL],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

router.isReady().then(() => {
  app.mount('#app');
});